export default function DashboardIndex() {
  return (
    <section className="hero is-medium has-text-centered">
      <div className="hero-body">
        <p className="title">You can select right menu</p>
      </div>
    </section>
  );
}
